import { CutlistOrderSummary } from '@cutr/constants/cutlist';
import { useTranslation } from 'react-i18next';

import Badge, { BadgeVariant } from '@/primitives/Badge';
import { dateFormatter } from '@/utils/format';

export const StatusBadge = ({
  status,
  updatedAt,
  submittedAt,
  quoteReadyAt,
  cancelledAt,
  llmAnalysisStartedAt,
}: Partial<CutlistOrderSummary>) => {
  const { t } = useTranslation();

  const getHoverText = () => {
    switch (status) {
      case 'draft':
        return {
          tooltip: updatedAt
            ? `${t('agent.updatedAt')}: ${dateFormatter(updatedAt)}`
            : '',
          badgeVariant: 'default',
        };
      case 'pending_analysis':
        return {
          tooltip: llmAnalysisStartedAt
            ? `${t('agent.llmAnalysisStartedAt')}: ${dateFormatter(
                llmAnalysisStartedAt
              )}`
            : '',
          badgeVariant: 'signal',
        };
      case 'quote_requested':
        return {
          tooltip: submittedAt
            ? `${t('agent.submittedAt')}: ${dateFormatter(submittedAt)}`
            : '',
          badgeVariant: 'signal',
        };
      case 'quote_ready':
        return {
          tooltip: quoteReadyAt
            ? `${t('agent.quote_ready')}: ${dateFormatter(
                quoteReadyAt as string
              )}`
            : '',
          badgeVariant: 'new',
        };
      case 'order_placed':
        return {
          tooltip: submittedAt
            ? `${t('agent.submittedAt')}: ${dateFormatter(
                submittedAt as string
              )}`
            : '',
          badgeVariant: 'success',
        };
      case 'cancelled':
        return {
          tooltip: cancelledAt
            ? `${t('agent.cancelledAt')}: ${dateFormatter(
                cancelledAt as string
              )}`
            : '',
          badgeVariant: 'alert',
        };
      default:
        return {
          tooltip: '',
          badgeVariant: 'default',
        };
    }
  };

  const { tooltip, badgeVariant } = getHoverText();

  return (
    <div className={tooltip ? 'tooltip' : ''} data-tooltip={tooltip}>
      <Badge variant={badgeVariant as BadgeVariant}>
        {t(`agent.${status}`)}
      </Badge>
    </div>
  );
};
